export default "<div *ngFor=\"let value of elementsValues\">\n\t<span  class=\"badge-light badge-pill margin-right\">{{value | translate}}</span>\n</div>\n";